module.exports = __webpack_public_path__ + "img/9791186053096.af9e6fcf.jpg";